export default {
  maxAdultNumber: 6,
  maxChildNumber: 6,
  maxRoomNumber: 7,
  maxAllowedTravelDurationDayBound: 5,
  defaultNumberOfPassengers: 2,
  defaultNumberOfAdults: 2,
  defaultNumberOfChildren: 0,
  defaultRoom: [
    {
      adults: 2,
      children: [],
      roomType: 'double'
    }
  ]
}
